import { Options } from '@/components/mi-dialog/MiDialog';
import DataTable, { TableOptions, TableVisibility, DatatableInterface } from '@/components/data-table/DataTable';
import { Component, Prop } from 'vue-property-decorator';
import AbstractDatatable from '@/components/CustomDatatable/AbstractDatatable';
import { Media, MediaTableHeader, MediaTypeEnum } from '@/models/Media';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';

@Component<MediaDatatable>({})
export default class MediaDatatable extends AbstractDatatable implements DatatableInterface {

  // #region @Props

  @Prop({ default: '' })
  protected mediaId!: string;

  @Prop({ default: MediaTypeEnum.PURCHASE_ORDER })
  protected mediaType!: MediaTypeEnum;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props

  protected defaultPage = 1;

  protected isShowingUploadMediaDialog = false;

  protected selectedMedia: null | Media = null;

  protected tableVisibility: TableVisibility = {
    checkboxes: false,
    search: false,
    title: false,
    limit: true,
    pagination: true,
  };

  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers

  protected onMediaUploaded(): void {
    this.refresh();
  }

  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters

  protected get page() {
    const result = localStorage.getItem(`${this.$route.name}_page`);
    return result ? Number(result) : this.defaultPage;
  }

  protected set page(page: number) {
    localStorage.setItem(`${this.$route.name}_page`, page.toString());
    this.defaultPage = page;
  }

  protected get tableOptions(): TableOptions {
    return {
      model: new Media()
        .filter({
          id: this.mediaId,
          type: this.mediaType,
        }),
      name: {
        singular: 'Attachment',
        plural: 'Attachments'
      },
      headers: [
        MediaTableHeader.name,
      ],
      actions: [
        {
          type: 'delete',
          label: 'delete',
          icon: 'delete',
          action: (datatable: DataTable, media: Media) => {
            this.selectedMedia = media;
            this.$store.dispatch('openDialog', this.deleteMediaDialogOptions);
          },
        },
      ],
      filters: [],
      add: () => this.isShowingUploadMediaDialog = true
    }
  }

  protected get deleteMediaDialogOptions(): Options {
    return {
      title: 'Delete attachment from purchase order',
      text: 'Are you sure you wish to delete this attachment from the purchase order?',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedMedia) {
              return;
            }

            this.selectedMedia
              .delete()
              .then((response: any) => {
                if (response) {
                  this.refresh(true);
                  this.selectedMedia = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          },
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedMedia = null;
          },
        },
      },
    };
  }

  // #endregion

  // #endregion

  // #region @Watchers
  // #endregion
}
